import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';

import { Button, CustomAutocomplete, Dialog, Select, Text } from 'components';
import { Field, Form, Formik } from 'formik';
import { useQuery } from 'hooks/useQuery';
import { accountService } from 'services';

import { validationSchema } from './validation';

export const ListProfilesDialog = ({ open, handleClose, profile = {}, reloadProfiles }) => {
  if (!open) return null;

  const [roles, , loadingRoles] = useQuery(() => accountService.listUserRoles(), []);

  const [xpcellUsers, , loadingXpcellUsers] = useQuery(() => accountService.listXpcellUsers(), []);

  const rolesOptions = (roles || []).map((role) => ({
    value: role.id,
    label: role.description,
  }));

  const xpcellUsersOptions = (xpcellUsers || []).map((user) => ({
    value: user.id,
    label: user.name || user.description || user.email,
  }));
  const rolesOptionsNew = rolesOptions.filter((item) => item.label !== 'TI');

  const onSubmitHandler = async (props, setFieldValue, resetForm) => {
    console.log(props);
    try {
      const updateData = {
        ...props.values,
        xpcell_user_id: props.values.xpcell_user_id?.value || props.values.xpcell_user_id,
      };

      await accountService.updateUser(updateData);
      toast.success('Usuário atualizado com sucesso.');
      await reloadProfiles();
      await handleClose();
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message);
    }
  };

  return (
    <Dialog
      maxWidth='xs'
      scroll='paper'
      onClose={handleClose}
      aria-labelledby='customized-dialog-title'
      open={open}
    >
      <Dialog.Title onClose={handleClose}>Usuário: {profile?.name}</Dialog.Title>
      <Dialog.Content>
        <Formik
          initialValues={{
            id: profile?.id,
            fullname: profile?.name,
            email: profile?.email,
            role_id: profile?.role_id,
            xpcell_user_id: profile?.xpcell_user_id,
          }}
          validationSchema={validationSchema}
        >
          {(props) => (
            <>
              <Form onSubmit={props.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} lg={12}>
                    <Field
                      label='Nome Completo'
                      name='fullname'
                      variant='outlined'
                      size='small'
                      component={Text}
                    />
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <Field
                      label='Email'
                      name='email'
                      variant='outlined'
                      size='small'
                      component={Text}
                    />
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <Field
                      size='small'
                      fullWidth
                      name='role_id'
                      variant='outlined'
                      label='Grupo'
                      options={rolesOptionsNew}
                      component={Select}
                    />
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <Field
                      name='xpcell_user_id'
                      label='Usuário Xpcell'
                      options={xpcellUsersOptions}
                      component={CustomAutocomplete}
                      size='small'
                      disabled={loadingXpcellUsers}
                    />
                  </Grid>

                  <Grid style={{ display: 'flex', justifyContent: 'end' }} container>
                    <Grid item xs={12} lg={3}>
                      <Button onClick={handleClose} color='primary'>
                        Fechar
                      </Button>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        onClick={() => onSubmitHandler(props)}
                      >
                        Atualizar
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Form>
            </>
          )}
        </Formik>
      </Dialog.Content>
    </Dialog>
  );
};
